interface OrganisationOption {
    name: string;
    realId: string;
}

interface BulkResult {
    status: string;
}

export function getEligibleOrganisations(
    organisations: OrganisationOption[],
    currentOrganisationId: string,
    hasPermission: (organisationId: string) => boolean,
): OrganisationOption[] {
    return organisations
        .filter((organisation) =>
            organisation.realId !== currentOrganisationId &&
            hasPermission(organisation.realId)
        )
        .sort((a, b) => String(a.name).localeCompare(String(b.name)));
}

export function toggleOrganisationSelection(selectedOrganisationIds: string[], organisationId: string): string[] {
    return selectedOrganisationIds.includes(organisationId)
        ? selectedOrganisationIds.filter((id) => id !== organisationId)
        : [...selectedOrganisationIds, organisationId];
}

export function countBulkInvitationResults(results: BulkResult[]): Record<string, number> {
    return (results || []).reduce((all, item) => {
        all[item.status] = (all[item.status] || 0) + 1;
        return all;
    }, {});
}
